import React from 'react';
import { useLayers } from '@agissc/ktag-map';
import EsriLayerSettings from './esrilayersettings/EsriLayerSettings';
import useAppState from '../../../AppStore';
import TopicLayerSettingsCommands from './TopicLayerSettingsCommands';
import Scrollable from '../../../components/scrollable/Scrollable';

const TopicLayerSettings = () => {
  const { data, isLoading } = useLayers();
  const currentTopicLayerId = useAppState((state) => state.currentTopicLayerId);
  const setActiveView = useAppState((state) => state.setActiveView);

  if (isLoading) return null;

  const topicLayer = currentTopicLayerId ? data?.[currentTopicLayerId] : null;

  if (!currentTopicLayerId || !topicLayer) {
    setActiveView('mapContent_tool_main');
    return null;
  }

  const { type, id, url, title, isPublic, metadataUrl, downloadUrl } = topicLayer;

  return (
    <div className="tooldialog__wrapper">
      <Scrollable>
        <div className="tooldialog__wrapper-content">
          {type === 'esriMapServer' ? (
            <>
              <h3 className="topic-sub-layer__title">{title}</h3>
              <EsriLayerSettings topicId={id} url={url} isPublic={isPublic} />
            </>
          ) : (
            <div className="topic-layer__item-settings">
              <h3>{title}</h3>
              <TopicLayerSettingsCommands
                metadataUrl={metadataUrl}
                downloadUrl={downloadUrl}
              />
            </div>
          )}
        </div>
      </Scrollable>
    </div>
  );
};

export default TopicLayerSettings;
